/**
 * EdenDate group meetings — self-hosted Jitsi.
 * Injects a 🎥 button in group chats; clicking opens a room and posts the link.
 */
import I18n from '@lib/langPack';

const BASE = 'https://meet.infchat.infinite.boo/';

function t(key: string, fallback?: string): string {
  try {
    const out = (I18n as any).format(key, true);
    if(typeof out === 'string' && out !== key) return out;
  } catch(e) {}
  return fallback || key;
}

function el<K extends keyof HTMLElementTagNameMap>(tag: K, cls?: string, text?: string) {
  const e = document.createElement(tag);
  if(cls) e.className = cls;
  if(text !== undefined) e.textContent = text;
  return e;
}

function currentPeerId(): number {
  const input = document.querySelector('.input-message-input[data-peer-id]') as HTMLElement;
  if(input?.dataset.peerId) return Number(input.dataset.peerId) || 0;
  const bubble = document.querySelector('.bubble[data-peer-id]') as HTMLElement;
  return Number(bubble?.dataset.peerId) || 0;
}

function isGroupChat(): boolean {
  const id = currentPeerId();
  if(!id) return false;
  // groups/channels use negative ids in tweb
  return id < 0 || !!document.querySelector('.bubble.is-group, .chat-info .peer-title[data-peer-id]');
}

function roomUrl(peerId: number) {
  const rnd = Math.random().toString(36).slice(2, 8);
  return BASE + 'Eden' + Math.abs(peerId) + '_' + rnd;
}

async function sendLink(url: string) {
  const field =
    (document.querySelector('.input-message-input[contenteditable="true"]') as HTMLElement) ||
    (document.querySelector('.chat-input [contenteditable="true"]') as HTMLElement);
  const btn = document.querySelector('.btn-send, .new-message-wrapper .btn-send') as HTMLElement;
  if(!field) return;
  field.textContent = `${t('Eden.Meet.Invite', '加入会议')}: ${url}`;
  field.dispatchEvent(new InputEvent('input', {bubbles: true}));
  setTimeout(() => { btn?.click(); }, 150);
}

export function startMeeting() {
  const peerId = currentPeerId();
  if(!peerId) return;
  const url = roomUrl(peerId);
  window.open(url, '_blank');
  sendLink(url);
}

export function injectMeetingButton() {
  const rp = document.querySelector('.eden-rp-btn');
  if(!rp || document.querySelector('.eden-meet-btn')) return;
  if(!isGroupChat()) return;

  const btn = el('button', 'eden-rp-btn eden-meet-btn', '🎥');
  btn.title = t('Eden.Meet.Start', '发起会议');
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    startMeeting();
  });
  rp.parentElement?.insertBefore(btn, rp);
}
